import aesReduxConstants from '../constants';

const currentProductReducer = function() {
  const __defaultCurrentProductState = {
    details: null,
    event: null,
    versions: [],
    loadingReadState: false,
    loading: true,
    ackInProgress: false,

    error: null,
  };

  const reducer = function(state, action) {
    const __constants = aesReduxConstants;
    if (state === undefined) state = __defaultCurrentProductState;

    let delta = {};
    switch (action.type) {
      case __constants.SET_CURRENT_PRODUCT_ACK_IN_PROGRESS:
        delta = { ackInProgress: action.ackInProgress };
        break;

      case __constants.GET_CURRENT_PRODUCT:
        delta = { loading: true };
        break;

      case __constants.GET_CURRENT_PRODUCT_SUCCESS:
        delta = { loading: false, error: null };
        break;

      case __constants.GET_CURRENT_PRODUCT_ERROR:
        delta = { loading: false, error: action.error };
        break;

      case __constants.GET_CURRENT_PRODUCT_EVENT:
        delta = { event: action.event };
        break;

      case __constants.GET_CURRENT_PRODUCT_EVENT_ERROR:
        delta = { error: action._error };
        break;
      case __constants.GET_CURRENT_PRODUCT_DETAILS:
        delta = { details: action.details };
        break;

      case __constants.SET_CURRENT_PRODUCT_LOADING:
        delta = { loading: action.loading };
        break;

      case __constants.SET_CURRENT_PRODUCT_AS_READ:
        delta = { loadingReadState: true };
        break;

      case __constants.SET_CURRENT_PRODUCT_AS_READ_SUCCESS:
        delta = { loadingReadState: false };
        break;
      case __constants.SET_CURRENT_PRODUCT_LOADING_READ:
        delta = { loadingReadState: action.loading };
        break;

      case __constants.GET_CURRENT_PRODUCT_VERSIONS:
        delta = { loading: false, versions: action.versions };
        break;

      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default currentProductReducer();
